import DisabilityCostBreakdownModal from "./DisabilityCostBreakdownModal";

export default DisabilityCostBreakdownModal;
